export default __webpack_public_path__ + "static/media/KLO.fa1630da.png";